const langConstants = {
  en: {
    search: "Search",
    gptSearchPlaceholder: "What would you like to watch today ?",
    gptHeading: "Let AI be your ultimate movie Guru!",
    gptError: "Oops, looks like there is an error fetching the GPT result!",
  },
  hindi: {
    search: "खोजें",
    gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे ?",
    gptHeading: "AI को अपना सर्वश्रेष्ठ फिल्मी गुरु बनने दें!",
    gptError: "उफ़, ऐसा लगता है कि GPT परिणाम लाने में कोई त्रुटि हुई है!",
  },
  marathi: {
    search: "शोधा",
    gptSearchPlaceholder: "तुम्हाला आज काय बघायला आवडेल?",
    gptHeading: "AI ला तुमचा अंतिम चित्रपट गुरु बनू द्या!",
    gptError: "उफ़, ऐसा लगता है कि GPT परिणाम लाने में कोई त्रुटि हुई है!",
  },
  sanskrit: {
    search: "समागम्",
    gptSearchPlaceholder: "अद्य भवन्तः किं द्रष्टुम् इच्छन्ति ?",
    gptHeading: "AI भवतः परमं चलचित्र गुरुः भवतु!",
    gptError: "उफ्, इदं दृश्यते यत् GPT परिणामं आनयितुं त्रुटिः अस्ति!",
  },
  spanish: {
    search: "Buscar",
    gptSearchPlaceholder: "¿Qué te gustaría ver hoy?",
    gptHeading: "Deja que la IA sea tu gurú cinematográfico definitivo!",
    gptError: "¡Vaya, parece que hay un error al obtener el resultado de GPT!",
  },
  german: {
    search: "Suchen",
    gptSearchPlaceholder: "Was möchtest du heute sehen?",
    gptHeading: "Lassen Sie KI Ihr ultimativer Film-Guru sein!",
    gptError:
      "Hoppla, beim Abrufen des GPT-Ergebnisses scheint ein Fehler aufgetreten zu sein!",
  },
  french: {
    search: "Chercher",
    gptSearchPlaceholder: "Qu’aimeriez-vous voir aujourd’hui ?",
    gptHeading: "Laissez l'IA devenir votre gourou ultime du cinéma!",
    gptError:
      "Oups, il semble qu'il y ait une erreur lors de la récupération du résultat GPT !",
  },
  chinese: {
    search: "寻找",
    gptSearchPlaceholder: "今天你想看什么？",
    gptHeading: "让 AI 成为你的终极电影大师！",
    gptError: "糟糕，获取 GPT 结果时似乎出现错误",
  },
  japanese: {
    search: "探す",
    gptSearchPlaceholder: "今日は何を見たいですか？",
    gptHeading: "AI を究極の映画の達人にしましょう！",
    gptError: "おっと、GPT 結果の取得中にエラーが発生したようです。",
  },
};

export default langConstants;
